module.exports = __webpack_public_path__ + "static/img/3.934f9b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/picGrop1/3.jpg
// module id = Ze29
// module chunks = 0